import { Ds } from "@accurx/design";
import styled from "styled-components";

import { useAppSelector } from "store/hooks";

import { checkIsVideoConsult } from "./SendMessageFormComponent";

export interface PatientResponseToggleProps {
    handleChange: (checked: boolean) => void;
}

const PatientResponseToggle = ({
    handleChange,
}: PatientResponseToggleProps) => {
    const isSecureEmail = useAppSelector(
        ({ account }) => account.user?.isSecureEmail || false,
    );
    const isVideoConsult = useAppSelector((state) =>
        checkIsVideoConsult(state),
    );
    const userEmail = useAppSelector(
        ({ account }) => account.user?.email || "",
    );

    if (isVideoConsult) {
        return null;
    }

    return (
        <div className="row">
            <div className="col-sm-12 mb-4">
                <Ds.Tooltip>
                    <Ds.Switch
                        size="small"
                        onCheckedChange={handleChange}
                        disabled={!isSecureEmail}
                        id="switch-control"
                    >
                        <Ds.Tooltip.Trigger>
                            <Ds.Switch.Toggle />
                        </Ds.Tooltip.Trigger>
                        <Ds.Switch.Label htmlFor="switch-control">
                            <Ds.Text as="span">
                                Allow a patient to reply once with text or up to
                                5 photos
                            </Ds.Text>
                            <br />
                            <Ds.Text as="span">
                                The patient's response will come back to{" "}
                                {userEmail}
                            </Ds.Text>
                        </Ds.Switch.Label>
                    </Ds.Switch>

                    {!isSecureEmail && (
                        <Ds.Tooltip.Content
                            style={{ zIndex: 2000 }}
                            side="right"
                        >
                            <StyledTooltipContent
                                size="small"
                                weight="bold"
                                color="white"
                            >
                                This feature is unavailable as you have logged
                                in with an insecure email address. Please log in
                                with either nhs.net or a secure email address.
                            </StyledTooltipContent>
                        </Ds.Tooltip.Content>
                    )}
                </Ds.Tooltip>
            </div>
        </div>
    );
};

const StyledTooltipContent = styled(Ds.Text)`
    max-width: 15rem;
`;

export default PatientResponseToggle;
